import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import './NewsVideosPage.css';

function NewsVideosPage() {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => { document.title = 'PEC - Noticias'; }, []);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'news', 'videos'

  // Mock data for news and videos - you can replace with real API data
  const newsItems = [
    {
      id: 1,
      type: 'news',
      title: 'Avances en Inteligencia Artificial transforman la industria tecnológica',
      summary: 'Las últimas innovaciones en IA están revolucionando múltiples sectores, desde la medicina hasta la educación.',
      source: 'TechCrunch',
      author: 'Sarah Chen',
      publishedAt: '2024-01-15T09:30:00Z',
      category: 'Tecnología',
      tags: ['IA', 'tecnología', 'innovación', 'futuro'],
      readTime: '3 min',
      engagement: { views: 12500, likes: 890, comments: 145 },
      thumbnail: 'https://via.placeholder.com/400x200/3b82f6/ffffff?text=AI+Tech',
      url: '#',
      priority: 'high'
    },
    {
      id: 2,
      type: 'video',
      title: 'Productividad Extrema: 10 Técnicas que Cambiarán tu Vida',
      summary: 'Descubre las mejores estrategias para maximizar tu productividad diaria y alcanzar tus objetivos.',
      source: 'YouTube - ProductivityGuru',
      author: 'María González',
      publishedAt: '2024-01-14T15:45:00Z',
      category: 'Productividad',
      tags: ['productividad', 'técnicas', 'organización', 'eficiencia'],
      duration: '15:32',
      engagement: { views: 45200, likes: 2100, comments: 387 },
      thumbnail: 'https://via.placeholder.com/400x200/10b981/ffffff?text=Productivity',
      url: '#',
      priority: 'medium'
    },
    {
      id: 3,
      type: 'news',
      title: 'Nuevas regulaciones financieras impactarán el mercado global',
      summary: 'Los bancos centrales anuncian cambios significativos en las políticas monetarias para 2024.',
      source: 'Financial Times',
      author: 'Robert Johnson',
      publishedAt: '2024-01-14T11:20:00Z',
      category: 'Finanzas',
      tags: ['finanzas', 'regulaciones', 'mercado', 'economía'],
      readTime: '5 min',
      engagement: { views: 8300, likes: 245, comments: 67 },
      thumbnail: 'https://via.placeholder.com/400x200/f59e0b/ffffff?text=Finance',
      url: '#',
      priority: 'high'
    },
    {
      id: 4,
      type: 'video',
      title: 'Masterclass: Gestión de Tiempo para Profesionales Ocupados',
      summary: 'Aprende a gestionar tu tiempo como un experto con técnicas probadas por ejecutivos de Fortune 500.',
      source: 'YouTube - TimeManager Pro',
      author: 'Dr. Alex Rivera',
      publishedAt: '2024-01-13T20:15:00Z',
      category: 'Desarrollo Personal',
      tags: ['gestión-tiempo', 'liderazgo', 'profesional', 'masterclass'],
      duration: '28:45',
      engagement: { views: 67800, likes: 3450, comments: 892 },
      thumbnail: 'https://via.placeholder.com/400x200/8b5cf6/ffffff?text=Time+Management',
      url: '#',
      priority: 'medium'
    },
    {
      id: 5,
      type: 'news',
      title: 'Startups de IA recaudan cifras récord en inversión',
      summary: 'El sector de la inteligencia artificial atrae más de $50 billones en financiamiento durante el primer trimestre.',
      source: 'VentureBeat',
      author: 'Lisa Park',
      publishedAt: '2024-01-13T14:30:00Z',
      category: 'Startups',
      tags: ['startups', 'inversión', 'IA', 'financiamiento'],
      readTime: '4 min',
      engagement: { views: 15700, likes: 432, comments: 89 },
      thumbnail: 'https://via.placeholder.com/400x200/ef4444/ffffff?text=Startup+News',
      url: '#',
      priority: 'medium'
    },
    {
      id: 6,
      type: 'video',
      title: 'Cómo Construir Hábitos que Realmente Funcionen - Ciencia Aplicada',
      summary: 'Basado en neurociencia y psicología, descubre el método científico para crear hábitos duraderos.',
      source: 'YouTube - Science of Success',
      author: 'Dr. Jennifer Kim',
      publishedAt: '2024-01-12T18:00:00Z',
      category: 'Ciencia',
      tags: ['hábitos', 'neurociencia', 'psicología', 'ciencia'],
      duration: '22:18',
      engagement: { views: 123400, likes: 5670, comments: 1234 },
      thumbnail: 'https://via.placeholder.com/400x200/06b6d4/ffffff?text=Habits+Science',
      url: '#',
      priority: 'high'
    }
  ];

  // Filter content based on search term and active tab
  const filteredContent = newsItems.filter(item => {
    const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.summary.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesTab = activeTab === 'all' || item.type === activeTab.slice(0, -1); // Remove 's' from 'news' or 'videos'
    
    return matchesSearch && matchesTab;
  });

  // Calculate stats
  const totalNews = newsItems.filter(item => item.type === 'news').length;
  const totalVideos = newsItems.filter(item => item.type === 'video').length;
  const highPriorityItems = newsItems.filter(item => item.priority === 'high').length;
  // eslint-disable-next-line no-unused-vars
  const totalViews = newsItems.reduce((sum, item) => sum + item.engagement.views, 0);

  const handleItemAction = (itemId, action) => {
    console.log(`${action} item:`, itemId);
    // Implement item action functionality
  };

  const handleAddSource = () => {
    console.log('Adding new news source');
    // Implement add source functionality
  };

  const formatViews = (views) => {
    if (views >= 1000000) return `${(views / 1000000).toFixed(1)}M`;
    if (views >= 1000) return `${(views / 1000).toFixed(1)}K`;
    return views.toString();
  };

  const formatDate = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Hoy';
    if (diffDays === 2) return 'Ayer';
    if (diffDays <= 7) return `Hace ${diffDays} días`;
    return date.toLocaleDateString();
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'gray';
      default: return 'gray';
    }
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Tecnología': 'blue',
      'Productividad': 'green', 
      'Finanzas': 'yellow',
      'Desarrollo Personal': 'purple',
      'Startups': 'red',
      'Ciencia': 'cyan'
    };
    return colors[category] || 'gray';
  };

  return (
    <div className="news-page">
      <Header 
        currentPage="news" 
        showSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showAddButton 
        onAddNew={handleAddSource}
      />

      <div className="news-content">
        {/* News Stats */}
        <div className="news-stats">
          <div className="stat-card total">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <h3>{totalNews + totalVideos}</h3>
              <p>Total de Contenido</p>
            </div>
          </div>
          <div className="stat-card news">
            <div className="stat-icon">📰</div>
            <div className="stat-content">
              <h3>{totalNews}</h3>
              <p>Artículos de Noticias</p>
            </div>
          </div>
          <div className="stat-card videos">
            <div className="stat-icon">🎥</div>
            <div className="stat-content">
              <h3>{totalVideos}</h3>
              <p>Videos</p>
            </div>
          </div>
          <div className="stat-card priority">
            <div className="stat-icon">🔥</div>
            <div className="stat-content">
              <h3>{highPriorityItems}</h3>
              <p>Alta Prioridad</p>
            </div>
          </div>
        </div>

        {/* Content Filters */}
        <div className="content-filters">
          <div className="filter-tabs">
            <button 
              className={`filter-tab ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              🌐 Todo ({newsItems.length})
            </button>
            <button 
              className={`filter-tab ${activeTab === 'news' ? 'active' : ''}`}
              onClick={() => setActiveTab('news')}
            >
              📰 Noticias ({totalNews})
            </button>
            <button 
              className={`filter-tab ${activeTab === 'videos' ? 'active' : ''}`}
              onClick={() => setActiveTab('videos')}
            >
              🎥 Videos ({totalVideos})
            </button>
          </div>
          <div className="filter-actions">
            <button className="btn-secondary">Filtros</button>
            <button className="btn-secondary">Ordenar</button>
            <button className="btn-secondary">Exportar</button>
          </div>
        </div>

        {/* Content List */}
        <div className="content-section">
          <div className="section-header">
            <h2>Contenido Reciente ({filteredContent.length})</h2>
            <div className="view-options">
              <button className="view-btn active" title="Vista de tarjetas">⊞</button>
              <button className="view-btn" title="Vista de lista">☰</button>
            </div>
          </div>

          <div className="content-list">
            {filteredContent.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">📰</div>
                <h3>No se encontró contenido</h3>
                <p>Intenta ajustar los términos de búsqueda o cambiar los filtros</p>
              </div>
            ) : (
              filteredContent.map((item) => (
                <div key={item.id} className={`content-card ${item.type} ${getCategoryColor(item.category)}`}>
                  <div className="content-header">
                    <div className="content-thumbnail">
                      <img src={item.thumbnail} alt={item.title} />
                      <div className="content-type-badge">
                        {item.type === 'video' ? '🎥' : '📰'}
                      </div>
                      <div className={`priority-badge ${getPriorityColor(item.priority)}`}>
                        {item.priority.toUpperCase()}
                      </div>
                    </div>
                    <div className="content-meta">
                      <div className="content-title-row">
                        <h4 className="content-title">{item.title}</h4>
                        <div className="content-timing">
                          {item.type === 'video' ? (
                            <span className="duration">⏱️ {item.duration}</span>
                          ) : (
                            <span className="read-time">📖 {item.readTime}</span>
                          )}
                        </div>
                      </div>
                      <p className="content-summary">{item.summary}</p>
                      <div className="content-details">
                        <span className={`content-category ${getCategoryColor(item.category)}`}>
                          {item.category}
                        </span>
                        <span className="content-source">📡 {item.source}</span>
                        <span className="content-author">👤 {item.author}</span>
                        <span className="content-date">📅 {formatDate(item.publishedAt)}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="content-body">
                    <div className="content-tags">
                      {item.tags.map((tag, index) => (
                        <span key={index} className="content-tag">
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="content-engagement">
                    <div className="engagement-stats">
                      <span className="stat">👁️ {formatViews(item.engagement.views)}</span>
                      <span className="stat">👍 {formatViews(item.engagement.likes)}</span>
                      <span className="stat">💬 {item.engagement.comments}</span>
                    </div>
                  </div>
                  
                  <div className="content-actions">
                    <button 
                      className="btn-action primary"
                      onClick={() => handleItemAction(item.id, 'read')}
                    >
                      {item.type === 'video' ? 'Ver Video' : 'Leer Artículo'}
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleItemAction(item.id, 'bookmark')}
                    >
                      🔖 Guardar
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleItemAction(item.id, 'share')}
                    >
                      📤 Compartir
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleItemAction(item.id, 'hide')}
                    >
                      👁️‍🗨️ Ocultar
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions-section">
          <h2>Gestión de Fuentes</h2>
          <div className="quick-actions-grid">
            <div className="quick-action-card">
              <div className="action-icon">📡</div>
              <h3>RSS Feeds</h3>
              <p>Configurar feeds RSS personalizados</p>
              <button className="btn-primary">Configurar</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">🎥</div>
              <h3>YouTube</h3>
              <p>Gestionar canales de YouTube suscritos</p>
              <button className="btn-primary">Administrar</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">🔔</div>
              <h3>Notificaciones</h3>
              <p>Alertas para contenido importante</p>
              <button className="btn-primary">Configurar</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">📊</div>
              <h3>Analytics</h3>
              <p>Estadísticas de consumo de contenido</p>
              <button className="btn-primary">Ver Reportes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsVideosPage;
